import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@occc/ui-design-system';

import { PointChangeViewItem } from './PointChangeViewItem';
import { PointChangeViewItemData } from './types';
import { PointChangeViewSubItem } from './PointChangeViewSubItem';

type Props = {
  items: PointChangeViewItemData[];
};

const hasSubItem = (item: PointChangeViewItemData) =>
  Boolean(item.offer || item.donation || item.referralProgram);

const renderPointChangeViewSubItem = (item: PointChangeViewItemData) => {
  if (item.offer) {
    return (
      <PointChangeViewSubItem
        name={item.offer.name}
        title={item.offer.title}
        link={item.offer.url}
        total={item.amount}
      />
    );
  }

  if (item.donation) {
    return (
      <PointChangeViewSubItem name={item.donation.bucketName} total={item.donation.pointsSpent} />
    );
  }

  if (item.referralProgram) {
    return (
      <PointChangeViewSubItem
        name={item.referralProgram.name}
        link={item.referralProgram.url}
        total={item.amount}
      />
    );
  }

  return null;
};

export const PointChangeViewItems = (props: Props) => {
  const { items } = props;
  const hasDates = items.some((v) => v.offer && (v.offer.startDate || v.offer.endDate));

  return (
    <TableContainer
      sx={(theme) => ({
        marginBottom: theme.spacing(1),
      })}
    >
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Item</TableCell>
            {hasDates && (
              <>
                <TableCell>Start Date</TableCell>
                <TableCell>End Date</TableCell>
              </>
            )}
            <TableCell align='right'>Amount</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item) => (
            <PointChangeViewItem key={item.id} item={item} isAmountHidden={hasSubItem(item)}>
              {renderPointChangeViewSubItem(item)}
            </PointChangeViewItem>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
